import { render, staticRenderFns } from "./pre-doc.vue?vue&type=template&id=60e7bb29&scoped=true"
import script from "./pre-doc.vue?vue&type=script&lang=js"
export * from "./pre-doc.vue?vue&type=script&lang=js"
import style0 from "./pre-doc.vue?vue&type=style&index=0&id=60e7bb29&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e7bb29",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60e7bb29')) {
      api.createRecord('60e7bb29', component.options)
    } else {
      api.reload('60e7bb29', component.options)
    }
    module.hot.accept("./pre-doc.vue?vue&type=template&id=60e7bb29&scoped=true", function () {
      api.rerender('60e7bb29', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/correspondence/pre-doc.vue"
export default component.exports